import { MAX_WIDTH, MAX_HEIGHT, JPEG_QUALITY } from "./config.state";

export function resizeAndCompressImage(file, maxW = MAX_WIDTH, maxH = MAX_HEIGHT, quality = JPEG_QUALITY) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      try {
        let { width, height } = img;
        let targetW = width;
        let targetH = height;

        if (width > maxW || height > maxH) {
          const aspect = width / height;
          if (aspect > 1) {
            targetW = Math.min(width, maxW);
            targetH = Math.round(targetW / aspect);
            if (targetH > maxH) {
              targetH = maxH;
              targetW = Math.round(targetH * aspect);
            }
          } else {
            targetH = Math.min(height, maxH);
            targetW = Math.round(targetH * aspect);
            if (targetW > maxW) {
              targetW = maxW;
              targetH = Math.round(targetW / aspect);
            }
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, targetW, targetH);

        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(url);
            if (!blob) return reject(new Error("Compression failed — toBlob returned null"));
            resolve(blob);
          },
          "image/jpeg",
          quality
        );
      } catch (err) {
        URL.revokeObjectURL(url);
        reject(err);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image for compression"));
    };

    img.src = url;
  });
}
